import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full py-16 md:py-20 px-4" data-id="element-141">
      <div className="max-w-4xl mx-auto" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-bg-warm border border-line rounded-3xl p-8 md:p-12 shadow-sm" data-id="element-143">
          <div className="grid md:grid-cols-[auto,1fr] gap-7 items-center" data-id="element-144">
            <div className="flex justify-center md:justify-start" data-id="element-145">
              <div className="relative w-32 h-32 md:w-40 md:h-40 rounded-full bg-bg-warm border-4 border-rose flex flex-col items-center justify-center shadow-lg" data-id="element-146">
                <ShieldCheckIcon className="w-10 h-10 text-rose mb-1" data-id="element-147" />
                <div className="font-serif text-2xl font-bold text-ink leading-none" data-id="element-148">
                  7 días
                </div>
                <div className="text-[10px] tracking-widest text-rose font-bold mt-1" data-id="element-149">
                  GARANTÍA
                </div>
              </div>
            </div>
            <div className="text-center md:text-left" data-id="element-150">
              <div className="text-xs font-bold text-rose tracking-widest mb-3 uppercase" data-id="element-151">
                🛡️ Garantía 7 días — Sin preguntas
              </div>
              <h3 className="font-serif font-bold text-2xl md:text-3xl text-ink mb-3 uppercase tracking-tight" data-id="element-152">
                Probalo sin{' '}
                <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-153">
                  riesgo
                </span>
              </h3>
              <p className="text-ink-soft leading-relaxed" data-id="element-154">
                Si en 7 días sentís que esta colección no es lo que esperabas,
                te devolvemos el 100% de tu inversión. Sin preguntas. Sin
                trámites.
              </p>
              <p className="text-sm text-muted mt-3" data-id="element-155">
                Tasa de devoluciones: menos del 1%.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}